import React, { useState } from 'react';
import { getDeluxeEnvironment, setDeluxeEnvironment } from '../../../services/payment/deluxeEnvironment';

const DeluxeEnvironmentToggle = ({ onEnvironmentChange }) => {
  const [environment, setEnvironment] = useState(() => getDeluxeEnvironment());

  const handleChange = (nextEnv) => {
    setDeluxeEnvironment(nextEnv);
    setEnvironment(nextEnv);
    onEnvironmentChange?.(nextEnv);
  };

  return (
    <div className="rbs-info-banner" style={{ marginTop: 12 }}>
      Deluxe environment is
      {' '}
      <select
        value={environment}
        onChange={(e) => handleChange(e.target.value)}
        style={{ marginLeft: 8 }}
      >
        <option value="SANDBOX">Sandbox</option>
        <option value="PRODUCTION">Production</option>
      </select>
    </div>
  );
};

export default DeluxeEnvironmentToggle;
